import axios from "axios";
import config from "@assets/config.json"; // api 请求json

const state = {};
const mutations = {};
const getters = {};
const actions = {
  getApplyCompanyGetAreas ({ rootState }, opt) {
    // 健身获取展区
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ApplyCompany/GetAreas`, opt, rootState.commonHeader)
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getApplyCompanyGetAreasNew ({ rootState }, opt) {
    // 药品交易会获取展区
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ApplyCompany/GetAllArea`, opt, rootState.commonHeader)
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getApplyCompanyRoastCreate ({ rootState }, opt) {
    // 健身新增展会
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ApplyCompany/NHNECreate`, opt, rootState.commonHeader).then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getExhibitionById ({
    rootState
  }, id) {
    // 根据展会id
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/exhibition?id=${id}`, rootState.commonHeader)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  getCategoryByGroupIdLevel ({
    rootState
  }) {
    // 获取一级参展展品
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/Category/ByGroupId?groupId=11&level=-1&loadChild=false`, rootState.commonHeader)
        .then(data => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch(err => {
          console.log(err);
        });
    });
  },
  createExhibitionPayAttention ({ rootState }, opt) {
    // 展会注意事项
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ExhibitionPayAttention`, opt, rootState.header)
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editExhibitionPayAttention ({ rootState }, opt) {
    // 展会注意事项
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/ExhibitionPayAttention`, opt, rootState.header)
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getExhibitionPayAttentionByExId ({ rootState }, exhibitionId) {
    // 展会注意事项
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/ExhibitionPayAttention/GetByExId?Exid=${exhibitionId}`, rootState.header)
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },


  createExhibitionLink ({ rootState }, opt) {
    // 展会注意事项
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/ExhibitionLink`, opt, rootState.header)
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editExhibitionLink ({ rootState }, opt) {
    // 展会注意事项
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/ExhibitionLink`, opt, rootState.header)
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getExhibitionLinkByExId ({ rootState }, exhibitionId) {
    // 展会注意事项
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/ExhibitionLink/GetByExId?Exid=${exhibitionId}`, rootState.header)
        .then(({ data }) => {
          if (data) {
            resolve(data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



